import config from 'constants/config'
import { isEnabledForFeature } from 'lib/featureFlagUtils'

function shouldRenderWhatsApp(region: string) {
  return config.WHATS_APP_NUMBER && isEnabledForFeature(config.WHATS_APP_COUNTRIES, region)
}

export default shouldRenderWhatsApp
